<template>
  <el-form :inline="true" class="demo-ruleForm">
    <el-dialog
      :title="$t('commomArea.addGateway')"
      :modal-append-to-body="false"
      :lock-scroll="false"
      :visible.sync="addGatewayVisible"
      width="400px"
    >
      <el-form :inline="true" :model="gatewayForm" ref="gatewayForm" class="demo-ruleForm">
        <el-form-item
          :label="$t('commomArea.gatewayName')"
          label-width="120px"
          prop="addGatewayName"
          :rules="[{required: true, message: $t('commomArea.gatewayName-input')}]"
        >
          <el-input
            v-model="gatewayForm.addGatewayName"
            :placeholder="$t('commomArea.gatewayName')"
            maxlength="30"
            show-word-limit
            style="width:200px"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('commomArea.number')"
          label-width="120px"
          prop="addGatewayNum"
          :rules="[{ required: true, message: $t('commomArea.number-input')}]"
        >
          <el-input
            v-model="gatewayForm.addGatewayNum"
            :placeholder="$t('commomArea.number')"
            maxlength="20"
            show-word-limit
            style="width:200px"
          ></el-input>
        </el-form-item>
        <el-form-item style="display:flex;justify-content:center;align-items:center;">
          <el-button type="primary" @click="addGateway()">{{$t('commomArea.confirm')}}</el-button>
          <el-button type="primary" @click="addGatewayVisible=false">{{$t('commomArea.cancel')}}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      :title="$t('commomArea.addOffLineLock')"
      :modal-append-to-body="false"
      :lock-scroll="false"
      :visible.sync="addOfflineVisible"
      width="400px"
    >
      <el-form :inline="true" :model="offlineForm" ref="offlineForm" class="demo-ruleForm">
        <el-form-item
          :label="$t('commomArea.lockNum')"
          label-width="120px"
          prop="lockId"
          :rules="[{ required: true, message: $t('commomArea.lockNum-input')}]"
        >
          <el-input 
          v-model="offlineForm.lockId" :placeholder="$t('commomArea.lockNum')" 
          maxlength="8"
          show-word-limit 
          style="width:200px"></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('commomArea.deviceName')"
          label-width="120px"
          prop="lockName"
          :rules="[{ required: true, message: $t('commomArea.deviceName-input')}]"
        >
          <el-input
            v-model="offlineForm.lockName"
            :placeholder="$t('commomArea.deviceName')"
            maxlength="30"
            show-word-limit
            style="width:200px"
          ></el-input>
        </el-form-item>
        <el-form-item style="display:flex;justify-content:center;align-items:center;">
          <el-button type="primary" @click="addOfflineLock()">{{$t('commomArea.confirm')}}</el-button>
          <el-button type="primary" @click="addOfflineVisible=false">{{$t('commomArea.cancel')}}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      :title="$t('commomArea.addNetworkLock')"
      :modal-append-to-body="false"
      :lock-scroll="false"
      :visible.sync="addNetLockVisible"
      width="400px"
    >
      <el-form :inline="true" :model="netLockForm" ref="netLockForm" class="demo-ruleForm">
        <el-form-item :label="$t('commomArea.gateway')" label-width="120px">
          <el-select
            v-model="netLockForm.gatewayId"
            :placeholder="$t('commomArea.gateway-input')"
            style="width:200px"
            prop="gatewayId"
          >
            <el-option
              v-for="item in this.$store.state.gatewayList"
              :key="item.deviceId"
              :label="item.deviceName"
              :value="item.deviceId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('commomArea.lockNumber')" label-width="120px">
          <el-input 
           v-model="netLockForm.lockId" 
           :placeholder="$t('commomArea.lockNumber')" 
           maxlength="20"
           show-word-limit 
           style="width:200px"></el-input>
        </el-form-item>
        <el-form-item :label="$t('commomArea.lockName')" label-width="120px">
          <el-input 
          v-model="netLockForm.lockName" 
          :placeholder="$t('commomArea.lockName')" 
          maxlength="30"
          show-word-limit 
          style="width:200px"></el-input>
        </el-form-item>
        <el-form-item style="display:flex;justify-content:center;align-items:center;">
          <el-button type="primary" @click="addNetLock()">{{$t('commomArea.confirm')}}</el-button>
          <el-button type="primary" @click="addNetLockVisible=false">{{$t('commomArea.cancel')}}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-card class="box-card">
      <div slot="header" style="font-weight:bold;height:10px;line-height:10px">
        <span>{{this.infoData.apartmentType==0?$t('commomArea.publicArea'):this.currRoomData.floorName+"("+$t('commomArea.publicArea')+")"}}</span>
      </div>
      <div style="margin-top:-15px;height:180px;">
        <el-col :span="8" style="border-right:1px #000000 dashed;">
          <div style="width:100%;height:195px;">
            <el-col :span="24" style="height:30px">{{$t('commomArea.publicGateway')}}</el-col>
            <div v-for="d in this.$store.state.gatewayList" :key="d.deviceId" class="text item">
              <el-col :span="8" class="block">
                <el-col>
                  <el-image
                    :src="require('@/assets/wg.png')"
                    style="width: 40px;height:40px;cursor:pointer"
                    @click="gatewayDetail(d)"
                  ></el-image>
                </el-col>
                <el-col>
                  <span class="demonstration">{{d.deviceName}}</span>
                </el-col>
              </el-col>
            </div>
          </div>
        </el-col>
        <el-col :span="8" style="border-right:1px #000000 dashed;">
          <div style="width:100%;height:195px">
            <el-col :span="24">
              <div style="margin-left:10px">{{$t('commomArea.costDetails')}}</div>
            </el-col>
          </div>
        </el-col>
        <el-col :span="8">
          <div style="width:100%;height:195px;">
            <el-row style="margin-top:5px">
              <div>{{$t('commomArea.commonOperation')}}</div>
            </el-row>
            <el-form-item>
               <el-col :span="24" style="display:flex;justify-content:center;align-items:center;">
                <el-button style="margin-top:1px;width:180px" icon="el-icon-plus" type="primary" @click="addOfflineVisible=true">{{$t('commomArea.bindOffLineLock')}}</el-button>
               </el-col>
               <el-col :span="24" style="display:flex;justify-content:center;align-items:center;">
                <el-button style="margin-top:1px;width:180px" icon="el-icon-plus" type="primary" @click="addNetLockVisible=true">{{$t('commomArea.bindNetworkLock')}}</el-button>
               </el-col>
               <el-col :span="24" style="display:flex;justify-content:center;align-items:center;">
                 <el-button style="margin-top:1px;width:180px" icon="el-icon-plus" type="primary" @click="addGatewayVisible=true">{{$t('commomArea.bindGateway')}}</el-button>
               </el-col>  
             </el-form-item>
          </div>
        </el-col>
      </div>
    </el-card>

    <el-card class="box-card" style="margin-top:3px">
      <div slot="header" style="font-weight:bold;height:10px;line-height:10px">
        <span>{{$t('commomArea.publicDevice')}}</span>
      </div>
      <el-table
        :data="this.tableData"
        :header-cell-style="{background:'#eef1f6',color:'#606266'}"
        empty-text="No Data"
        border
      >
        <el-table-column type="index" :label="$t('commomArea.order')" width="100" align="center"></el-table-column>
        <el-table-column prop="deviceId" :label="$t('commomArea.lockNumber')" align="center"></el-table-column>
        <el-table-column prop="apartmentName" :label="$t('commomArea.apartmentName')" align="center"></el-table-column>
        <el-table-column prop="roomName" :label="$t('commomArea.roomName')" align="center"></el-table-column>
        <el-table-column prop="deviceName" :label="$t('commomArea.deviceName')" align="center"></el-table-column>
        <el-table-column prop="isOnline" :label="$t('commomArea.onlineStatus')" align="center"></el-table-column>
        <el-table-column prop :label="$t('commomArea.operate')" width="100" align="center">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-edit" :title="$t('commomArea.detail')" size="mini" @click="handleEdit(scope.$index, scope.row)"></el-button>
          </template>
        </el-table-column>
      </el-table>

      <div style="margin-top:3px">
        <Pagings
          :total="total"
          :offset="pageData.offset"
          :pageSize="pageData.pageNumber"
          @handleSizeChangeSub="handleSizeChange"
          @handleCurrentChangeSub="handleCurrentChange"
        ></Pagings>
      </div>
    </el-card>
  </el-form>
</template>
<script>
import Pagings from "../common/Pagings.vue";
export default {
  name: "commomAreea",
  props: ["infoData", "roomData", "tabIndex", "sonTabsItem"],
  data() {
    return {
      addGatewayVisible: false, //添加网关
      addOfflineVisible: false, //添加离线锁
      addNetLockVisible: false, //添加联网锁
      pageData: {
        offset: 1,
        pageNumber: 10
      },
      total: 1, //总条数
      tableData: [],
      gatewayForm: {
        addGatewayName: "(网关)" + this.roomData.floorName,
        addGatewayNum: ""
        // gatewayList:this.$store.state.gatewayList
      },
      offlineForm: {
        lockId: "",
        lockName: ""
      },
      netLockForm: {
        gatewayId: "",
        gatewayList: [],
        lockId: "",
        lockName: ""
      },
      currRoomData: this.roomData
    };
  },
  components: {
    Pagings
  },
  watch: {
    tabIndex(val) {
      var sonTabsItem = this.sonTabsItem;
      for (var str in sonTabsItem) {
        if (sonTabsItem[str].apartmentId == this.infoData.apartmentId) {
          var sonTabItemList = sonTabsItem[str].tabsItem;
          for (var s in sonTabItemList) {
            if (sonTabItemList[s].name == val &&val != 1 &&sonTabItemList[s].type == 0
            ) {
              this.currRoomData = sonTabItemList[s].ref;
              this.power();
              this.$store.commit("getApartmentRoomUsableGateway", {
                roomId: this.currRoomData.floorPublicRoom.roomId
              }); //加载网关详细
            }
          }
        }
      }
    }
  },
  created() {
    var sonTabsItem = this.sonTabsItem;
    for (var str in sonTabsItem) {
      if (sonTabsItem[str].apartmentId == this.infoData.apartmentId) {
        var sonTabItemList = sonTabsItem[str].tabsItem;
        for (var s in sonTabItemList) {
          if (sonTabItemList[s].name == this.tabIndex &&this.tabIndex != 1 &&sonTabItemList[s].type == 0
          ) {
            this.currRoomData = sonTabItemList[s].ref;
            this.power();
            this.$store.commit("getApartmentRoomUsableGateway", {
              roomId: this.currRoomData.floorPublicRoom.roomId
            }); //加载网关详细
          }
        }
      }
    }
  },
  methods: {
    sxkc() {
       this.$store.commit("getApartmentRoomUsableGateway", {
          roomId: this.currRoomData.floorPublicRoom.roomId
        }); //加载网关详细
      this.$forceUpdate();
    },
    handleEdit(index, row) {
      this.$mainInfo.addDevcieDetail(row);
    },
    gatewayDetail(gatewayData) {
      this.$mainInfo.addGatewayDetail(gatewayData);
    },
    addGateway() {
      //添加网关
      var formData = new FormData();
      formData.append("deviceName", this.gatewayForm.addGatewayName);
      formData.append("deviceId", this.gatewayForm.addGatewayNum);
      formData.append("deviceType", 0);
      formData.append("roomId", this.currRoomData.floorPublicRoom.roomId);
      this.$server
        .exam("/customer/apartment/bindFirstDevice", formData)
        .then(data => {
          if (data.code == 200) {
            var rtnData = data["data"][0];
            this.addGatewayVisible = false;
            const loading = this.$loading({
              lock: true,
              text: "Loading",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)"
            });
            var obj = {};
            obj.roomId=this.currRoomData.floorPublicRoom.roomId;
            // obj.apartmentId = this.infoData.apartmentId;
            obj.rId = rtnData.recordId;
            obj.loading = loading;
            obj.opType = "addGateway";
            this.$store.dispatch("checkResult", obj); //等待回调
          } else {
            this.$message({
              message: data.message,
              type: "warning"
            });
          }
        });
    },
    addOfflineLock() {
      //添加离线锁
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      var formData = new FormData();
      formData.append("deviceName", this.offlineForm.lockName);
      formData.append("lockPassword", this.offlineForm.lockId);
      formData.append("roomId", this.currRoomData.floorPublicRoom.roomId);
      this.$server
        .exam("/customer/apartment/bindOfflineLock", formData)
        .then(data => {
          loading.close();
          if (data.code == 200) {
            this.addOfflineVisible = false;
            this.$message({
              message: data.message,
              type: "warning"
            });
            this.power();
          } else {
            this.$message({
              message: data.message,
              type: "warning"
            });
          }
        });
    },
    addNetLock() {
      //添加联网锁
      var formData = new FormData();
      formData.append("firstDeviceId", this.netLockForm.gatewayId);
      formData.append("firstDeviceType", 0);
      formData.append("roomId", this.currRoomData.floorPublicRoom.roomId);
      formData.append("secondDeviceId", this.netLockForm.lockId);
      formData.append("secondDeviceName", this.netLockForm.lockName);
      formData.append("secondDeviceType", 1);
      this.$server
        .exam("/customer/apartment/bindSecondDevice", formData)
        .then(data => {
          if (data.code == 200) {
            var rtnData = data["data"][0];
            // this.addNetLockVisible=false;
            const loading = this.$loading({
              lock: true,
              text: "Loading",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)"
            });
            var obj = {};
            obj.apartmentId = this.infoData.apartmentId;
            obj.rId = rtnData.recordId;
            obj.loading = loading;
            obj.opType = "netLock";
            this.$store.dispatch("checkResult", obj); //等待回调
          } else {
            this.$message({
              message: data.message,
              type: "warning"
            });
          }
        });
    },
    power() {
      var formData = new FormData();
      formData.append("floorId", this.currRoomData.floorId);
      formData.append("isPublic", 1);
      formData.append("pageNo", this.pageData.offset);
      formData.append("pageSize", this.pageData.pageNumber);
      this.$server.exam("/customer/lock/listLock", formData).then(data => {
        if (data.code == 200) {
          this.tableData = data.data.records;
          this.total = data.data.total;
          // this.oAssEquipmentDto.offset = 1;
          // this.oAssEquipmentDto.pageNumber = data.data.pages;
        } else {
          this.$message({
            message: data.message,
            type: "warning"
          });
        }
      });
    },

    // getBindFirstDevice() {
    //   var formData = new FormData();
    //   formData.append("apartmentId", this.infoData.apartmentId);
    //   formData.append("deviceType", 0);
    //   this.$server
    //     .exam("/customer/apartment/getApartmentBindDevice", formData)
    //     .then(data => {
    //       if (data.code == 200) {
    //         this.netLockForm.gatewayList = data.data;
    //         // this.tableData = data.data.records;
    //         // this.total = data.data.total;
    //         // this.oAssEquipmentDto.offset = 1;
    //         // this.oAssEquipmentDto.pageNumber = data.data.pages;
    //       } else {
    //         this.$message({
    //           message: data.message,
    //           type: "warning"
    //         });
    //       }
    //     });
    // },

    handleSizeChange(val) {
      this.oAssEquipmentDto.pageNumber = val;
      this.power();
    },
    handleCurrentChange(val) {
      this.oAssEquipmentDto.offset = val;
      this.power();
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/device/commomArea.vue